<script>
	import IconShelf from './IconShelf.svelte';

	export let small = false;
	export let name;
	export let books = [
	];

	let height = "210px";
	if (Object.keys(books).length > 5) {
		height = "370px";
	}
</script>

<style>
	.reel-container {
		margin: 30px 0;
	}

	h2 {
		margin-top: 50px;
		margin-bottom: 0px;
		/*margin-left: 70px;*/
		/*text-align: center;*/
	}

	.reel {
		overflow-y: hidden;
		overflow-x: scroll;
		/*height: 200px;*/
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		align-content: flex-start;
		padding: 20px 60px;
		margin: 0 -70px;
		/*border-radius: 10px;*/
		background: #FFF;

		background-image: 
	
    /* Shadows */ 
    linear-gradient(to right, white, white),
    linear-gradient(to right, white, white),
  
/* Shadow covers */ 
    linear-gradient(to right, rgba(0,0,0,.35), rgba(255,255,255,0)),
    linear-gradient(to left, rgba(0,0,0,.35), rgba(255,255,255,0));   

  background-position: left center, right center, left center, right center;
	background-repeat: no-repeat;
	background-color: white;
	background-size: 20px 100%, 20px 100%, 10px 100%, 10px 100%;
	
	/* Opera doesn't support this in the shorthand */
	background-attachment: local, local, scroll, scroll;
	}
	.reel.small {
		/*height: 100px;*/
	}

	.reel-item {
		display: block;
		/*width: 100px;*/
		/*height: 150px;*/
		/*background: #EEE;*/
		/*margin: 0 5px;*/
		padding: 5px;
		/*width: 200px;*/
		/*height: 200px;*/
	}
	.reel-item.small {
		/*width: 50px;
		height: 75px;
		margin: 10px;*/
	}

	.reel-item * {
		display: block;
	}

	.img-cont {
		margin: 0 auto;
		width:90px;
		height:133px;
		line-height: 133px;
		vertical-align: middle;
	}

	img {
		/*display: block;*/
		vertical-align: middle;
		max-width:90px;
		max-height:133px;
		width: auto;
		height: auto;
		border-radius: 7px;
		margin: 0 auto;
		box-shadow: 0px 3px 16px -9px rgba(0,0,0,0.75);
	}
	.info {
		padding: 10px 0px 0px 10px;
		width: 170px;
		/*text-align: center;*/
	}
	.info.small {
		display: none;
	}
	.name {
		color: #333;
		font-weight: 600;
		/*padding-bottom: 5px;*/
		font-size: 14px;

		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}
	.author {
		color: #666;
		/*font-weight: 600;*/
		font-size: 12px;
		padding-top: 5px;
		padding-bottom: 5px;
	}
	.rating {
		font-size: 12px;
	}

	.availability {
		margin: 5px 0;
		font-size: 12px;
	}

	a {
		border-radius: 10px;
		/*background: #FFF;*/
		/*box-shadow: 0px 3px 16px -9px rgba(0,0,0,0.75);*/
		position:relative;
    	z-index:2;
    	color: inherit;
	}

	a:hover, a:active {
		background: #ff986e;
		box-shadow: 0px 3px 16px -9px rgba(0,0,0,0.75);
	}

	.reel-item-stuff {
		padding: 10px;
		display: flex;
		flex-direction: row;
	}

</style>


<div class="reel-container">
	<h2>{name}</h2>

	<div class="reel" style="height: {height}">
		{#each Object.entries(books) as [id, book]}
			<div class="reel-item" class:small>
				<a href="/book/{id}">
					<div class="reel-item-stuff">
						<div class="img-cont">
							<img src={book.image} />
						</div>
						<div class="info" class:small>

							<span class="name">{book.name}</span>
							<span class="author">{book.author || ""}</span>
							<span class="rating"><IconShelf icon="star" /> 4.3</span>
							<span class="availability">
								{#if book.available}
					                <IconShelf icon="shelf" /> In shelf
					              {:else}
					                <IconShelf icon="no" /> Reservable
					              {/if}
							</span>
						</div>
					</div>
				</a>
			</div>
		{/each}
	</div>
</div>
